import { EllipsedText, FlexRow, LabeledData, MaterialIcon, useMoment } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { Cell, Grid } from 'baseui/layout-grid';
import { StyledLink } from 'baseui/link';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { memo } from 'react';
import { useCamera } from '../../hooks/useCamera';
import { useStyles } from '../../hooks/useStyles';
import { LinkAssetDetail } from '../../types/link';
import { StyledCard } from '../shared/styledCard/StyledCard';
import { StyledCardBodyWrapper } from '../shared/styledCard/StyledCardBodyWrapper';
import { StyledCardDivider } from '../shared/styledCard/StyledCardDivider';
import { StyledCardHeaderWrapper } from '../shared/styledCard/StyledCardHeaderWrapper';
import { StyledTooltip } from '../ui/StyledTooltip';

type Props = {
  assetDetail: LinkAssetDetail;
  isPrimary?: boolean;
};

function LinkAssetCard({ assetDetail, isPrimary = false }: Props) {
  const { theme, css, classes } = useStyles();
  const { formatDateFromTs } = useMoment();
  const { zoomTo } = useCamera();

  return (
    <StyledCard>
      <StyledCardHeaderWrapper>
        <FlexRow
          gap={theme.sizing.scale200}
          classNames={`${classes.centeredStart} ${css({ flexWrap: 'wrap' })}`}
        >
          <StyledTooltip content="Identificador">
            <LabelMedium>{isPrimary ? 'Phone' : assetDetail.ident}</LabelMedium>
          </StyledTooltip>
          <StyledTooltip content="Etiqueta">
            <ParagraphSmall
              margin={0}
              color={theme.colors.contentSecondary}
            >
              <EllipsedText inline>{`(${assetDetail.label})`}</EllipsedText>
            </ParagraphSmall>
          </StyledTooltip>
        </FlexRow>
        <StyledTooltip
          content="Encontrar en el mapa"
          showArrow={false}
          placement="bottom"
          ignoreBoundary
        >
          <Button
            shape="circle"
            kind="tertiary"
            size="mini"
            onClick={() => zoomTo({ lat: assetDetail.position_latitude, lng: assetDetail.position_longitude })}
          >
            <MaterialIcon
              name="location_searching"
              size="mini"
            />
          </Button>
        </StyledTooltip>
      </StyledCardHeaderWrapper>
      <StyledCardDivider />
      <StyledCardBodyWrapper>
        <Grid
          gridColumns={1}
          gridGaps={[8]}
          gridGutters={[16]}
          gridMargins={[0]}
        >
          <Cell>
            <LabeledData
              label={'Dirección:'}
              content={
                <StyledLink
                  href={`https://maps.google.com/?q=${assetDetail.position_latitude},${assetDetail.position_longitude}`}
                  target="_blank"
                  style={{ color: theme.colors.contentSecondary, ...theme.typography.ParagraphSmall }}
                >
                  <EllipsedText
                    inline
                    breakAll
                  >
                    {assetDetail.geoReference}
                  </EllipsedText>
                </StyledLink>
              }
            />
          </Cell>
          <Cell>
            <LabeledData
              label={'Fecha:'}
              content={`${formatDateFromTs(+assetDetail.timestamp)}`}
            />
          </Cell>
        </Grid>
      </StyledCardBodyWrapper>
    </StyledCard>
  );
}

export default memo(LinkAssetCard);
